import axios, { API_URL } from './BaseService';

export async function getBaskets(refresh = false) {
    const response = await axios.get(`${API_URL}/baskets`, {
        params: refresh ? { refresh: 1 } : {},
        timeout: 60000
    });
    return response.data;
}

export async function buyBasket(key, assets) {
    const response = await axios.post(`${API_URL}/baskets/${key}/buy`, { assets }, {
        timeout: 120000
    });
    return response.data;
}

export async function sellBasket(key) {
    const response = await axios.post(`${API_URL}/baskets/${key}/sell`, null, {
        timeout: 120000
    });
    return response.data;
}
